// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>11</span>&nbsp;&nbsp;So that people will say,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#145;Truly, there is a harvest for the righteous;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;truly, there is a God who judges in the earth.&#146;<br> </p> </div></div>";
// Exports
module.exports = code;